import ReceivedUsedPart from './ReceivedUsedPart';
import { withI18n } from 'react-i18next';

export default withI18n()(ReceivedUsedPart);
